$( "path" ).hover(function() {
    var contentAsset = $(this).attr("data-info");
    if (contentAsset != null){
        $("#info-box").css("display", "block");
        $("#info-box").html($(this).data("info"));
    }

});

$("path, circle").mouseleave(function(e) {
    $("#info-box").css("display", "none");
});

$(document)
    .mouseover(function(e) {
        e.stopPropagation();
        $("#info-box").css("top", e.pageY - $("#info-box").height() - 35);
        $("#info-box").css("left", e.pageX - $("#info-box").width() / 2);
    })
    .mouseover();
